export const LOCALSTORAGE_KEYS = {
  THEME: 'theme',
  TAB_SELECTIONS: 'tab-selections',
}
